import { render, staticRenderFns } from "./userGroupPage.vue?vue&type=template&id=77a4716f&"
import script from "./userGroupPage.vue?vue&type=script&lang=ts&"
export * from "./userGroupPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports